import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

export const supportedLanguages = [
  {
    'code': 'cs',
    'name': 'Čeština',
    'muiLocale': 'csCS',
    'dateLocale': 'cs',
  },
  {
    'code': 'da',
    'name': 'Dansk',
    'muiLocale': 'daDK',
    'dateLocale': 'da',
  },
  {
    'code': 'de',
    'name': 'Deutsch',
    'muiLocale': 'deDE',
    'dateLocale': 'de',
  },
  {
    'code': 'el',
    'name': 'Ελληνικά (Elliniká)',
    'muiLocale': 'elGR',
    'dateLocale': 'el',
  },
  {
    'code': 'en',
    'name': 'English',
    'muiLocale': 'enUS',
    'dateLocale': 'en',
  },
  {
    'code': 'es',
    'name': 'Español',
    'muiLocale': 'esES',
    'dateLocale': 'es',
  },
  {
    'code': 'fr',
    'name': 'Français',
    'muiLocale': 'frFR',
    'dateLocale': 'fr',
  },
  {
    'code': 'it',
    'name': 'Italiano',
    'muiLocale': 'itIT',
    'dateLocale': 'it',
  },
  {
    'code': 'hu',
    'name': 'Magyar',
    'muiLocale': 'huHU',
    'dateLocale': 'hu',
  },
  {
    'code': 'ja',
    'name': '日本語 (Nihongo)',
    'muiLocale': 'jaJP',
    'dateLocale': 'ja',
  },
  {
    'code': 'nl',
    'name': 'Nederlands',
    'muiLocale': 'nlNL',
    'dateLocale': 'nl',
  },
  {
    'code': 'no',
    'name': 'Norsk',
    'muiLocale': 'noNO',
    'dateLocale': 'nb',
  },
  {
    'code': 'pl',
    'name': 'Polski',
    'muiLocale': 'plPL',
    'dateLocale': 'pl',
  },
  {
    'code': 'pt',
    'name': 'Português',
    'muiLocale': 'ptPT',
    'dateLocale': 'pt',
  },
  {
    'code': 'ro',
    'name': 'Română',
    'muiLocale': 'roRO',
    'dateLocale': 'ro',
  },
  {
    'code': 'ru',
    'name': 'Русский (Russkiy)',
    'muiLocale': 'ruRU',
    'dateLocale': 'ru',
  },
  {
    'code': 'sv',
    'name': 'Svenska',
    'muiLocale': 'svSE',
    'dateLocale': 'sv',
  },
  {
    'code': 'tr',
    'name': 'Türkçe',
    'muiLocale': 'trTR',
    'dateLocale': 'tr',
  },
  {
    'code': 'zh',
    'name': '中文 (Zhōngwén)',
    'muiLocale': 'zhCN',
    'dateLocale': 'zh-cn',
  },
];
i18n.use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: 'en',
    resources: {
      en: {
        translations: require('./locales/translations_en.json'),
      },
      de: {
        translations: require('./locales/translations_de.json'),
      },
      es: {
        translations: require('./locales/translations_es.json'),
      },
      fr: {
        translations: require('./locales/translations_fr.json'),
      },
      it: {
        translations: require('./locales/translations_it.json'),
      },
      sv: {
        translations: require('./locales/translations_sv.json'),
      },
      zh: {
        translations: require('./locales/translations_zh.json'),
      },
      ru: {
        translations: require('./locales/translations_ru.json'),
      },
      pt: {
        translations: require('./locales/translations_pt.json'),
      },
      ja: {
        translations: require('./locales/translations_ja.json'),
      },
      nl: {
        translations: require('./locales/translations_nl.json'),
      },
      da: {
        translations: require('./locales/translations_da.json'),
      },
      no: {
        translations: require('./locales/translations_no.json'),
      },
      pl: {
        translations: require('./locales/translations_pl.json'),
      },
      cs: {
        translations: require('./locales/translations_cs.json'),
      },
      ro: {
        translations: require('./locales/translations_ro.json'),
      },
      el: {
        translations: require('./locales/translations_el.json'),
      },
      hu: {
        translations: require('./locales/translations_hu.json'),
      },
      tr: {
        translations: require('./locales/translations_tr.json'),
      },
    },
    ns: ['translations'],
    defaultNS: 'translations',
  });

i18n.languages = supportedLanguages.map((language) => language.code);

export default i18n;
